"use client";
'use strict';

var React = require('react');
var _function = require('../utils/function.js');

function useCountDown(props) {
    const { from = 0, to, speed = 500, interval = 100, formatter } = props;
    const [count, setCount] = React.useState(from);
    React.useEffect(() => {
        setCount(from);
        const loops = Math.ceil(speed / interval);
        let loopsCount = 0;
        const intervalCallback = setInterval(() => {
            if (loops > loopsCount) {
                loopsCount += 1;
                setCount((count) => {
                    const increment = (to - count) / loops;
                    return count + increment;
                });
            }
            else {
                clearInterval(intervalCallback);
                setCount(to);
            }
        }, interval);
        return () => clearInterval(intervalCallback);
    }, [from, interval, speed, to]);
    const value = React.useMemo(() => {
        const nextValue = _function.runIfFn(formatter, count);
        return nextValue !== undefined ? nextValue : count;
    }, [count, formatter]);
    return value;
}

exports.useCountDown = useCountDown;
//# sourceMappingURL=useCountDown.js.map
